import { BottomSheet, Host, RNHostView } from '@expo/ui';
import { XIcon } from 'lucide-react-native';
import * as React from 'react';
import { ScrollView, View } from 'react-native';

import { Button } from '@sixam/ui/button';
import { Text } from '@sixam/ui/text';

type EventDetailSheetProps = Readonly<{
  children: React.ReactNode;
  isPresented: boolean;
  onDismiss: () => void;
  title: string;
}>;

export function EventDetailSheet({
  children,
  isPresented,
  onDismiss,
  title,
}: EventDetailSheetProps) {
  const [canPresent, setCanPresent] = React.useState(false);

  React.useEffect(() => {
    const frame = requestAnimationFrame(() => setCanPresent(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return (
    <Host matchContents>
      <BottomSheet
        isPresented={canPresent && isPresented}
        onDismiss={onDismiss}
        showDragIndicator
        snapPoints={['half', 'full']}
      >
        <RNHostView style={{ backgroundColor: 'transparent', height: '100%', width: '100%' }}>
          <ScrollView
            className="flex-1"
            contentContainerClassName="gap-5 px-6 pb-10 pt-2"
            contentInsetAdjustmentBehavior="automatic"
            style={{ backgroundColor: 'transparent' }}
          >
            <View className="min-h-14 flex-row items-center justify-between gap-4 border-b border-border pb-3">
              <Text variant="h3" className="min-w-0 flex-1">
                {title}
              </Text>
              <Button
                accessibilityLabel={`Close ${title}`}
                onPress={onDismiss}
                size="icon"
                variant="ghost"
              >
                <XIcon size={18} />
              </Button>
            </View>
            {children}
          </ScrollView>
        </RNHostView>
      </BottomSheet>
    </Host>
  );
}
